import React from 'react';
import { ShoppingBag, Rocket, Briefcase, Building } from 'lucide-react';
export function Industries() {
  const industries = [{
    icon: ShoppingBag,
    title: 'eCommerce',
    description: 'Support for online retailers, handling order inquiries, returns, and product questions.'
  }, {
    icon: Rocket,
    title: 'SaaS & Startups',
    description: 'Technical support and customer success for growing software companies.'
  }, {
    icon: Briefcase,
    title: 'Service Businesses',
    description: 'Appointment scheduling and inquiry management for professional service providers.'
  }, {
    icon: Building,
    title: 'Real Estate',
    description: 'Tenant support, maintenance coordination, and property inquiry handling.'
  }];
  return <section id="industries" className="py-20 bg-slate-900 text-white" data-id="element-160">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-161">
        <div className="text-center mb-16" data-id="element-162">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-4" data-id="element-163">
            Industries We Serve
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-164">
            We tailor our support strategies to meet the unique challenges of
            your specific industry.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-165">
          {industries.map((industry, index) => <div key={index} className="bg-slate-800/50 rounded-xl p-6 border border-slate-700 hover:bg-slate-800 transition-colors duration-300" data-id="element-166">
              <industry.icon className="h-10 w-10 text-blue-400 mb-4" data-id="element-167" />
              <h3 className="text-xl font-bold mb-2" data-id="element-168">{industry.title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed" data-id="element-169">
                {industry.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}